import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { AgGauge } from 'ag-charts-angular';

import { AppRoutingModule } from './app-routing.module';

import { AuthService } from './core/services/auth.service';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { CacheInterceptor } from './core/interceptors/cache.interceptor';

import './core/config/ag-grid.config';
import { ErrorHandlerService } from './core/services/error-handler.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({
    declarations: [
        // Remove AppComponent and LayoutComponent from declarations
        // They are standalone components
    ],
    imports: [
        BrowserModule,
        CommonModule,
        RouterModule,
        AppRoutingModule,
        ReactiveFormsModule,
        AgGridModule,
        AgGauge        
    ],
    providers: [
        provideAnimations(),
        provideAnimationsAsync(),
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        { provide : ErrorHandler, useClass : ErrorHandlerService},
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
    ],
    // Remove bootstrap array since we're using standalone bootstrapping in main.ts
})
export class AppModule { }